import { useSearchParams } from "react-router-dom";
import { StaffLawyerProfileForm } from "./StaffLawyerProfileForm";

export function LawyerProfileNew() {
  const [params] = useSearchParams();
  const initialCompanyId = params.get("companyId") ?? undefined;
  return <StaffLawyerProfileForm mode="create" initialCompanyId={initialCompanyId} />;
}

export default LawyerProfileNew;
